import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSendMessage } from 'crustate/react';
import { useTranslate } from '@awardit/react-use-translate';
import { Wrapper, ButtonLink } from '@crossroads/ui-components';
import { makeUsePollOrderStatus, SUCCESS_STATUSES } from '../../helpers/use-poll-order-status.js';
import { Pixel } from '../../components/Pixel/index.js';
import { ArrowSvg } from '../../icons/index.js';
import Cookies from 'js-cookie';
import cn from 'classnames';
import styles from 'shop-views/SuccessView.scss';

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _temp(e) {
  console.log("Could not subcribe to newsletter", e);
}

function _empty() {}

var formatAddress = a => `
  ${a.firstname} ${a.lastname},
  ${a.street[0]}, ${a.postcode},
  ${a.city}`;

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

var SuccessView = _ref => {
  function _temp2() {
    if (orderData.state === "LOADED" && orderData.data && orderData.data.email) {
      return _continueIgnored(_catch(_client, _temp));
    }
  }

  function _client() {
    return _awaitIgnored(client(subscribeToNewsletter, {
      email: orderData.data.email
    }));
  }

  var analytics = _ref.analytics,
      orderData = _ref.orderData,
      useClient = _ref.useClient,
      formatPrice = _ref.formatPrice,
      subscribeToNewsletter = _ref.subscribeToNewsletter,
      _ref$additionalField = _ref.additionalField,
      additionalField = _ref$additionalField === void 0 ? "NONE" : _ref$additionalField,
      customAdditionalField = _ref.customAdditionalField,
      _ref$hasVisiblePrices = _ref.hasVisiblePrices,
      hasVisiblePrices = _ref$hasVisiblePrices === void 0 ? true : _ref$hasVisiblePrices,
      loadOrder = _ref.loadOrder,
      CheckIcon = _ref.CheckIcon,
      ChatIcon = _ref.ChatIcon,
      PhoneIcon = _ref.PhoneIcon;

  var _useState = useState(true),
      pollingOrderStatus = _useState[0],
      setPollingOrderStatus = _useState[1];

  var t = useTranslate();
  var client = useClient();
  var sendMessage = useSendMessage();
  var pollOrderConfig = useMemo(() => ({
    onSuccess: () => {
      sendMessage(loadOrder());
      setPollingOrderStatus(false);
    },
    onError: () => {
      setPollingOrderStatus(false);
    }
  }), []);
  var pollOrderStatus = makeUsePollOrderStatus(client)(pollOrderConfig);
  useEffect(() => {
    if (orderData.state === "LOADED") {
      if (!orderData.data || !SUCCESS_STATUSES.includes(orderData.data.status)) {
        pollOrderStatus();
      } else {
        setPollingOrderStatus(false);
      }
    }
  }, [orderData, pollOrderStatus]);
  useEffect(() => {
    // @TODO: fix totalPoints for B2B etc
    if (orderData.state === "LOADED" && orderData.data) {
      setTimeout(() => {
        analytics.registerCheckoutSuccess(orderData.data, 0);
      }, 1000);
    }
  }, [orderData, analytics]);
  /* Look into subscribe useEffect, prevalence */

  useEffect(() => {
    if (!subscribeToNewsletter) {
      return;
    }

    var subscribeCookie = Cookies.get("opt-email");
    var userSubscribed = subscribeCookie ? JSON.parse(subscribeCookie) : false;

    var subscribeToNewsletterCallback = function subscribeToNewsletterCallback() {
      return _await(_invokeIgnored(_temp2));
    };

    if (userSubscribed) {
      subscribeToNewsletterCallback();
    }
  }, [orderData, client]);

  if (pollingOrderStatus || orderData.state !== "LOADED") {
    return /*#__PURE__*/React.createElement(Wrapper, {
      className: styles.wrapper
    }, /*#__PURE__*/React.createElement(Helmet, {
      title: t("SUCCESS.TITLE")
    }), /*#__PURE__*/React.createElement(DummyView, null));
  }

  if (!orderData.data) {
    return /*#__PURE__*/React.createElement(Wrapper, {
      className: styles.wrapper
    }, /*#__PURE__*/React.createElement(Helmet, {
      title: t("SUCCESS.TITLE")
    }), /*#__PURE__*/React.createElement("header", {
      className: styles.header
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
      className: styles.title
    }, t("SUCCESS.NOT_FOUND_TITLE"))), /*#__PURE__*/React.createElement("div", {
      className: styles.back
    }, /*#__PURE__*/React.createElement("img", {
      alt: "",
      src: ArrowSvg,
      className: styles.backArrow
    }), /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, t("SUCCESS.BACK")))), /*#__PURE__*/React.createElement("div", {
      className: styles.success
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.left
    }, /*#__PURE__*/React.createElement("h3", null, t("SUCCESS.NOT_FOUND_SUBTITLE")))));
  }

  var order = orderData.data;
  var id = order.id,
      items = order.items,
      addresses = order.addresses,
      email = order.email;
  var shippingAddress = addresses.find(x => x.type === "shipping");
  var isVirtual = order.items.every(x => x.product.type === "virtual" || x.configOption && x.configOption.product.type === "virtual");
  var isMixed = order.items.some(x => x.product.type === "virtual" || x.configOption && x.configOption.product.type === "virtual");
  var tKey = isVirtual ? "VIRTUAL" : isMixed ? "MIXED" : "NORMAL";
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: t("SUCCESS.TITLE")
  }), /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.mainTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.checkIconBG
  }, CheckIcon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: styles.title
  }, t("SUCCESS.TITLE")), /*#__PURE__*/React.createElement("h2", {
    className: styles.orderNo
  }, t("SUCCESS.SUB_TITLE", {
    number: id
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.back
  }, /*#__PURE__*/React.createElement("img", {
    src: ArrowSvg,
    className: styles.backArrow
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, t("SUCCESS.BACK")))), /*#__PURE__*/React.createElement("div", {
    className: styles.success
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.subHeading
  }, t("SUCCESS.ORDER_OVERVIEW")), /*#__PURE__*/React.createElement("div", {
    className: styles.items
  }, items.map(x => {
    var _product$attributes$i;

    var product = x.configOption ? _extends({}, x.product, x.configOption.product) : _extends({}, x.product);
    return /*#__PURE__*/React.createElement("div", {
      key: product.sku,
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.itemContainer
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.itemImage,
      src: (_product$attributes$i = product.attributes.image) == null ? void 0 : _product$attributes$i.x1,
      alt: product.name
    }), /*#__PURE__*/React.createElement("div", {
      className: cn(styles.itemInfo, {
        [styles.hidePrice]: !hasVisiblePrices
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.generalInfo
    }, /*#__PURE__*/React.createElement("p", {
      className: styles.name
    }, product.name), /*#__PURE__*/React.createElement("p", {
      className: styles.brand
    }, product.attributes.manufacturer)), hasVisiblePrices && /*#__PURE__*/React.createElement("div", {
      className: styles.itemPrice
    }, /*#__PURE__*/React.createElement("span", null, formatPrice(x.rowTotal.incVat))))));
  })), shippingAddress && !isVirtual && /*#__PURE__*/React.createElement("section", {
    className: cn(styles.mapContainer, styles.mapContainer__large)
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.subHeading
  }, t(`SUCCESS.STEPS.${tKey}.4.HEADING`)), /*#__PURE__*/React.createElement("p", {
    className: styles.mapText
  }, formatAddress(shippingAddress)))), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement(InstructionSteps, {
    tKey: tKey,
    isVirtual: isVirtual,
    email: email
  }), additionalField !== "NONE" && /*#__PURE__*/React.createElement(AdditionalField, {
    ChatIcon: ChatIcon,
    PhoneIcon: PhoneIcon,
    type: additionalField,
    customField: customAdditionalField
  }))));
};
var AdditionalField = _ref2 => {
  var ChatIcon = _ref2.ChatIcon,
      PhoneIcon = _ref2.PhoneIcon,
      type = _ref2.type,
      customField = _ref2.customField;
  var t = useTranslate();

  if (type === "CUSTOM" && customField !== null && customField !== undefined) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.customAdditionalField
    }, customField);
  }

  if (type === "CONTACT_INFO") {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.contactInfo
    }, /*#__PURE__*/React.createElement("h2", null, t("SUCCESS.CONTACT.HEADING")), /*#__PURE__*/React.createElement("p", null, t("SUCCESS.CONTACT.TEXT")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: t("SUCCESS.CONTACT.LINK")
    }, t("SUCCESS.CONTACT.LINK_TEXT"))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.customerService
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.subHeading
  }, t("SUCCESS.CONTACT.TITLE")), /*#__PURE__*/React.createElement("div", {
    className: styles.contactContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contactColumn
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, ChatIcon, /*#__PURE__*/React.createElement("span", null, t("SUCCESS.CONTACT.CREATE_TICKET"))), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t("SUCCESS.CONTACT.INFO")
    }
  }), /*#__PURE__*/React.createElement(ButtonLink, {
    target: "_blank",
    to: t("META.HELPDESK_LINK"),
    variant: "primary"
  }, t("SUCCESS.CONTACT.CREATE_TICKET")))), /*#__PURE__*/React.createElement("div", {
    className: styles.contactColumn
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, PhoneIcon, /*#__PURE__*/React.createElement("span", null, t("SUCCESS.CONTACT.CALL_US"))), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: t("SUCCESS.CONTACT.CALL_US_HOURS")
    }
  }), /*#__PURE__*/React.createElement("a", {
    href: `tel:${t("SUCCESS.CONTACT.CALL_US_PHONENUMBER")}`
  }, t("SUCCESS.CONTACT.CALL_US"))))));
};
var InstructionSteps = _ref3 => {
  var tKey = _ref3.tKey,
      isVirtual = _ref3.isVirtual,
      email = _ref3.email;
  var t = useTranslate();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: styles.subHeading
  }, t("SUCCESS.WHAT_NOW")), /*#__PURE__*/React.createElement("ol", {
    className: styles.steps
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("h3", null, "1. ", t(`SUCCESS.STEPS.${tKey}.1.HEADING`)), /*#__PURE__*/React.createElement("p", null, t(`SUCCESS.STEPS.${tKey}.1.TEXT`, {
    email
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("h3", null, "2. ", t(`SUCCESS.STEPS.${tKey}.2.HEADING`)), /*#__PURE__*/React.createElement("p", null, t(`SUCCESS.STEPS.${tKey}.2.TEXT`, {
    email
  }))), !isVirtual && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("h3", null, "3. ", t(`SUCCESS.STEPS.${tKey}.3.HEADING`)), /*#__PURE__*/React.createElement("p", null, t(`SUCCESS.STEPS.${tKey}.3.TEXT`, {
    email
  }))), !isVirtual && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("h3", null, "4. ", t(`SUCCESS.STEPS.${tKey}.4.HEADING`)), /*#__PURE__*/React.createElement("p", null, t(`SUCCESS.STEPS.${tKey}.4.TEXT`, {
    email
  })))));
};
var DummyView = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.dummy
  }, /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: styles.title
  }, "\xA0"), /*#__PURE__*/React.createElement("h2", {
    className: styles.orderNo
  }, "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: styles.headerRight
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.backField
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.back
  }, "\xA0")))), /*#__PURE__*/React.createElement("div", {
    className: styles.success
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.subHeading
  }, "\xA0"), /*#__PURE__*/React.createElement("div", {
    className: styles.items
  }, [...Array.from({
    length: 2
  })].map((x, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: styles.item
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.itemContainer
  }, /*#__PURE__*/React.createElement(Pixel, {
    className: styles.itemImage
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.itemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.generalInfo
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.name
  }, "\xA0"), /*#__PURE__*/React.createElement("p", {
    className: styles.brand
  }, "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: styles.itemPrice
  }, /*#__PURE__*/React.createElement("span", null, "\xA0")))))))), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.subHeading
  }, "\xA0"), /*#__PURE__*/React.createElement("ol", {
    className: styles.steps
  }, [...Array.from({
    length: 3
  })].map((x, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles.smallHeading
  }, "\xA0"), /*#__PURE__*/React.createElement("p", null, "\xA0"), /*#__PURE__*/React.createElement("p", null, "\xA0")))))));
};

export { AdditionalField, DummyView, InstructionSteps, SuccessView };
//# sourceMappingURL=index.js.map
